import remote from "../../../../services/remote";
import {getPatientDetailsFailure, getPatientDetailsSuccess} from "./actions";
import {GET_PATIENT_DETAILS_REQUEST} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getDetails(action) {
    try {
        const response = yield call(remote, {
            route: `/admin/patients/get-patient-details/${action.data.patientId}`,
            method: 'get'
        });
        if (response.success) {
            yield put(getPatientDetailsSuccess(response.data));
        } else {
            yield put(getPatientDetailsFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAdminPatientDetails() {
    yield takeLatest(GET_PATIENT_DETAILS_REQUEST , getDetails);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/PatientDetails/saga.js